// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/project/sdk/components/footer/footer.scss
// module id = 195
// module chunks = 0